import { ConnectionTier } from '../model/types/classroom/enums'

export const CONNECTION_SAMPLE_INTERVAL_MS = 1000
export const CONNECTION_RATING_SUSTAIN_MS = 10_000
export const CONNECTION_RECOVERY_SUSTAIN_MS = 30_000
export const CONNECTION_BLAME_SUSTAIN_MS = 5000
export const CONNECTION_START_GRACE_MS = 45_000
export const CONNECTION_CPU_LIMITATION_HOLD_MS = 30_000
export const CONNECTION_UPLINK_LOSS_PCT_MIN = 2
export const CONNECTION_RECONNECTING_MS = 3000
export const CONNECTION_PEER_LOST_MS = 5000
export const CONNECTION_JOIN_SUPPRESSION_MS = 10_000
export const CONNECTION_WARNING_THROTTLE_MS = 60_000
export const CONNECTION_NOTICE_UNSTABLE_MS = 6000
export const CONNECTION_NOTICE_RECOVERY_MS = 4000

export const RECEPTION_WINDOW_MS = 20_000
export const RECEPTION_JUDGED_SAMPLES_MIN = 20
export const RECEPTION_FROZEN_SECONDS_MIN = 6
export const RECEPTION_CONCEALMENT_RATIO_MAX = 0.1
export const RECEPTION_STALL_MS = 3000
export const RECEPTION_SHARE_HEARTBEAT_MS = 5000
export const RECEPTION_SHARE_TTL_MS = 12_000

export const CONNECTION_TIER_RANK: Record<ConnectionTier, number> = {
  [ConnectionTier.Lost]: 0,
  [ConnectionTier.Weak]: 1,
  [ConnectionTier.Unstable]: 2,
  [ConnectionTier.Good]: 3,
}
